import React from 'react';
import { Stack, Typography, Grid } from '@mui/material';
import { Chip } from '@components/chip';
import { Times } from '@assets/svgs';
import { TTableFilter } from '@components/table/types';

type CustomFilterChipsProps = {
  customFilterChips: {
    label: string;
    value: string;
    filter: TTableFilter;
    idToFind?: string;
  }[];
  handleRemoveFilter: (fieldKey: string, idToFind?: string) => void;
};

export const CustomFilterChips: React.FC<CustomFilterChipsProps> = ({ customFilterChips, handleRemoveFilter }) => {
  if (!customFilterChips.length) {
    return null;
  }

  return (
    <Grid size={{ xs: 12 }}>
      <Stack
        direction='row'
        sx={{
          alignItems: 'center',
          flexWrap: 'wrap',
          gap: '8px',
        }}
      >
        <Typography
          variant='caption'
          sx={{
            color: 'primary.dark',
            marginRight: '8px',
            fontWeight: 'bold',
          }}
        >
          Custom filters
        </Typography>
        {customFilterChips.map(({ label, value, filter, idToFind }) => (
          <Chip
            key={`${label}: ${value}`}
            label={`${label}: ${value}`}
            deleteIcon={<Times width='9px' height='9px' color='common.white' style={{ marginRight: '12px' }} />}
            onDelete={() => handleRemoveFilter(filter.field, idToFind)}
            variant='filled'
          />
        ))}
      </Stack>
    </Grid>
  );
};
